import Login from './Login/Login';
import Logo from '../../components/Logo/Logo';
import NavBar from './NavBar/NavBar';
import { useState, useEffect } from 'react';
import Button from '../../components/Button/Button';

const Header = () => {
  const [isOpen, setOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 767.98) {
        setOpen(false);
        setIsMobile(true);
      } else {
        setOpen(true);
        setIsMobile(false);
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  const toggleMenu = () => {
    setOpen(!isOpen);
  };
  const getMenuButtonText = () => {
    return isOpen ? 'CLOSE' : 'MENU';
  };
  return (
    <header className='header'>
      <div className='header__container'>
        <Logo />
        <div className={`header__menu menu ${!isOpen ? 'closed' : ''}`}>
          <nav className='menu__body'>
            <NavBar className='menu' setOpen={setOpen} isMobile={isMobile} />
          </nav>
        </div>
        {isMobile && (
          <Button
            className='header__button text-menu'
            variant='secondary'
            onClick={toggleMenu}
          >
            {getMenuButtonText()}
          </Button>
        )}
        {!isMobile && <Login className='header__login login' />}
      </div>
    </header>
  );
};
export default Header;
